import type { MemberWebcam, MemberWebcamApiUser } from '../../types'
import { canListMemberWebcam } from './memberAccess'

export const WEBCAM_SELECTION = {
    MALE: 1,
    FEMALE: 2,
    NOT_SPECIFIED: 4,
    TSTVTG: 8,
    NON_DEFAULT: 16,
} as const

export type MemberGenderBucket = Exclude<
    keyof typeof WEBCAM_SELECTION,
    'NON_DEFAULT'
>

// mirrors the www option; the page filters genders with its own chips
export const DEFAULT_WEBCAM_SELECTION_MASK = 23

export const memberGenderBucket = (gender?: string): MemberGenderBucket => {
    if (gender === 'Male') return 'MALE'
    if (gender === 'Female') return 'FEMALE'
    if (gender === 'TS/TV/TG') return 'TSTVTG'
    return 'NOT_SPECIFIED'
}

export const memberWebcamServer = (user: MemberWebcamApiUser) =>
    Number(user.videoserver) || 0

export const isWatchableMemberWebcam = (user: MemberWebcamApiUser) => {
    if (!user.broadcasting_video || !memberWebcamServer(user)) return false
    return canListMemberWebcam(Number(user.access_level))
}

export const toMemberWebcam = (user: MemberWebcamApiUser): MemberWebcam => ({
    id: user.user_id,
    name: user.username,
    age: user.age ? parseInt(user.age, 10) || null : null,
    gender: user.gender || '',
    topic: user.blurb || '',
    about: user.about_me || '',
    color: user.chat_text_color || '',
    hasAvatar: typeof user.avatars === 'number' ? user.avatars > 0 : undefined,
})

export const isMemberIdParam = (param?: string) =>
    !!param && /^\d+$/.test(param)

export const resolveMemberParam = (
    param: string | undefined,
    known: Array<Pick<MemberWebcam, 'id' | 'name'>>,
    lookupId?: number,
) => {
    if (!param) return null
    if (isMemberIdParam(param)) return Number(param) || null
    const name = param.toLowerCase()
    return (
        known.find((member) => member.name.toLowerCase() === name)?.id ??
        lookupId ??
        null
    )
}
